import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { AccountItem, TypeaheadService } from '../../../services/typeahead.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-trav-exp-type',
  templateUrl: './trav-exp-type.component.html',
  styleUrls: ['./trav-exp-type.component.css']
})
export class TravExpTypeComponent implements OnInit {
    trexTypeId;

    public edit?: Edit;

    public selectListGlyphicons: Item[] = [];

    public selectListCompanies: BusinesscoItem[] = [];

    public glyphiconColour: string = '';

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) {
        this.trexTypeId = this.stateService.getStateParams()['trextype_id'];
    }

    private async loadEdit() {
        if (!!this.trexTypeId) {
            this.edit = (await this.datatask.Post(1271, { trextype_id: this.trexTypeId }))[0];
        }
    }

    private async loadGlyphicons() {
        this.selectListGlyphicons = await this.datatask.Post(1270);
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies('0');
    }

    public searchAccountNames = () => {
        return this.typeahead.lookUpSearchAccounts({
            searchtext: this.edit!.account_name,
            businessco_no: this.edit!.businessco_no
        });
    }

    public onAccountNameSelected(event?: AccountItem) {
        if (!this.edit) return;

        this.edit.account_no = !!event ? '' + event.item_id : '0';
        this.edit.account_name = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1272, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'glyphicon':
                this.showGlyphiconSymbol();
                break;
            default:
                break;
        }
    }

    public async showGlyphiconSymbol() {
        if (!this.edit) return;
        if (!this.glyphiconColour) return;

        const selected = this.selectListGlyphicons.find((item?: Item) => item?.item_id === this.edit?.glyphicon);

        if (selected) {
            this.edit!.glyphicon = selected.item_glyphicon ?? '';
            this.glyphiconColour = selected.item_glyphicon_color ?? '';
        }
    }

    private async init() {
        this.loadEdit();
        this.loadGlyphicons();
        this.loadCompanies();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    trextype_id: string;
    trextype_lang_name: string;
    isactive: string;
    glyphicon: string;
    businessco_no: string;
    account_name: string;
    account_no: string;
}
